var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assets-type-label",on:{"click":_vm.clickItem}},[_c('span',[_vm._v(_vm._s(_vm.data.code + ' ' + _vm.data.name))]),(_vm.isSelect)?_c('fm-btn',{staticClass:"assets-type-label-btn",staticStyle:{"margin-left":"1rem"},attrs:{"size":"small"},on:{"click":_vm.chooseIt}},[_vm._v("选择")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }